import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Page } from 'tesseract.js';

@Injectable({
  providedIn: 'root',
})
export class SearhService {
  constructor(private http: HttpClient) { }
  searchByNameAndWarehouse(query: string, warehouse_id: number): Observable<any> {
    const payload = { query, warehouse_id };
    return this.http.post<any>(
      `${environment.Server_URL}/stocks/search-by-name-warehouse`,
      payload
    );
  }

}
